import * as React from 'react'
import Dropzone from 'react-dropzone'
import { Avatar, CircularProgress, Icon } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const Component = ({
  onDrop,
  accept,
  src,
  loading = false,
  style = {},
  ...props
}) => {
  const s = useStyle({})

  return (
    <Dropzone onDrop={onDrop} accept={accept} disabled={loading} {...props}>
      {({ getRootProps, getInputProps }) => (
        <section style={style}>
          <div {...getRootProps()} className={s.content}>
            <Avatar src={src} className={s.avatar}>
              {!src && <Icon style={{ fontSize: '3rem' }}>person</Icon>}
            </Avatar>
            <input {...getInputProps()} />
            {loading && <CircularProgress classes={{ root: s.progress }} />}
          </div>
        </section>
      )}
    </Dropzone>
  )
}

const ComposedComponent = Component

export default ComposedComponent

const useStyle = makeStyles({
  content: {
    display: 'inline-block',
    cursor: 'pointer',
    position: 'relative',
  },
  avatar: {
    height: 100,
    width: 100,
  },
  progress: {
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -20,
  },
})
